<template>
    <el-dialog :title="title" top="0px" width="72%" :visible.sync="dialogVisible" append-to-body>
        <!-- <iframe :src="url" frameborder="no" id="iframe_11" name="iframe_11"
                                                                             class="tab_iframe" sandbox="allow-scripts" style="width: 100%; height: 500px;">
                                                                                </iframe> -->
        <el-container style="height: 500px; border: 1px solid #eee">
            <el-aside width="150px" style="background-color: rgb(238, 241, 246)">
                <el-menu default-active="2" class="el-menu-vertical-demo" @select="menuSelect">
                    <div v-for="(item) in dataItemTree" :key="item.id">
                        <el-menu-item :index="item.value">
                            <!-- <i class="el-icon-location"></i> -->
                            <span>{{item.text}}</span>
                        </el-menu-item>
                    </div>
                </el-menu>
            </el-aside>
            <el-container>
                <el-main>
                    <el-input placeholder="请输入流程名称进行搜索" v-model="workflowTitle" class="input-with-select" @keyup.enter.native="workflowSearch">
                        <el-button slot="append" icon="el-icon-search" @click="workflowSearch"></el-button>
                    </el-input>
                    <div class="cardProcess" v-for="item in CustmerSchemeList" :key="item.F_Id" @click="onFocus(item)" @dblclick="previewForm(item)">
                        <el-card class="box-card" :class="{focus:isFocus(item)}">
                            <div slot="header" class="cardheader clearfix">
                                <span>{{item.F_Name}}</span>
                            </div>
                            <div class="text item">
                                编号：{{item.F_Code}}
                            </div>
                            <div class="bottom clearfix" v-html="item.F_Description">
                            </div>
                        </el-card>
                    </div>
                </el-main>
            </el-container>
        </el-container>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="onSubmit">确 定</el-button>
            <el-button type="danger" @click="dialogVisible = false">关 闭</el-button>
        </div>
        <previewFormDialog ref="previewForm"></previewFormDialog>
    </el-dialog>
</template>

<script>
    import {
        getToken
    } from '@/util/auth';
    import previewFormDialog from './PreviewFormDialog.vue'
    export default {
        components: {
            previewFormDialog
        },
        data() {
            return {
                dialogVisible: false,
                workflowTitle:'',
                dataItemTree: [],
                CustmerSchemeList: [],
                SchemeList: [],
                workflow: {},
                title: '选择固定流程',
                url: this.Backstage_ROOT + '/WorkFlowModule/WfScheme/PreviewForm?schemeId=da73c968-1937-47e0-8835-68af16bad94d'
            }
        },
        methods: {
            onFocus: function(row) {
                this.workflow = row;
                this.title = '选择固定流程-' + row.F_Name + '(' + row.F_Code + ')';
            },
            isFocus: function(row) {
                if (row.F_Id == this.workflow.F_Id) return true;
                else return false;
            },
            workflowSearch(){
                if(this.workflowTitle)
                this.CustmerSchemeList = this.SchemeList.filter(p => p.F_Name.indexOf(this.workflowTitle)>-1)
                else
                this.CustmerSchemeList = this.SchemeList
            },
            menuSelect(index) {
                this.CustmerSchemeList = this.SchemeList.filter(p => p.F_Category === index)
            },
            onSubmit() {
                if (Object.keys(this.workflow).length == 0) {
                    this.$message.warning('请选择流程')
                    return;
                }
                this.$emit("Process", this.workflow)
                this.dialogVisible = false;
            },
            previewForm(row) {
                var winHeight = window.document.documentElement.clientHeight - 60;
                var winWidth = window.document.documentElement.clientWidth - 100;
                window.open(this.Backstage_ROOT + '/WorkFlowModule/WfScheme/PreviewForm?schemeId=' + row.F_SchemeId, "_blank", "height=" + winHeight +
                    ",width=" + winWidth +
                    ",top=30,left=30,toolbar=no, menubar=no, scrollbars=yes, resizable=yes");
            }
        }
    }
</script>

<style scoped>
    /* .el-col {
                                                                    border-radius: 4px;
                                                                    text-align: left;
                                                                } */
    .el-header {
        background-color: #B3C0D1;
        color: #333;
        line-height: 60px;
    }
    .el-aside {
        color: #333;
    }
    .el-aside {
        border-right: solid 1px #e6e6e6;
        background-color: white;
    }
    .cardProcess {
        width: 31%;
        float: left;
        padding: 5px;
    }
    .el-main {
        padding: 5px;
    }
    .cardProcess .el-card__header {
        padding: 5px 20px;
    }
    .cardheader {
        color: #409EFF;
    }
    .el-card {
        height: 150px;
    }
    /* .el-card:hover {
                    background-color:lightblue;
                    color: white;
                } */
    .focus {
        box-shadow: #5cbeff 0 0 18px!important;
        ;
    }
    .el-dialog__body {
        padding: 0px 0px;
    }
</style>